Foundation.Magellan.defaults.animationEasing = "swing";
Foundation.Magellan.defaults.animationDuration = 350;
Foundation.Magellan.defaults.offset = -27;
